import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {EmailNotificationModel} from '../../../../../../models';

@Injectable({ providedIn: 'root' })
export class InternalSalesEmailNotificationService extends BaseApiTemplateService<EmailNotificationModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX
      + 'internal-sales-orders/email-notification/backoffice-ep';

    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX
      + 'internal-sales-orders/email-notification/backoffice-ep';
    this.httpClient = http;
  }

  sendEmailNotification(guid, dtoObject: EmailNotificationModel, visa: ApiVisa) {
    let url = this.apiUrl + '/' + guid;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/' + guid;
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }
}
